function t(t){try{const n=new URL(t);return n.hostname.includes(".")&&n.protocol.startsWith("https")}catch(t){return!1}}export{t as validateURL};
